import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonComponent } from '@shared/components/btn/button.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { FiltroFechaComponent } from './components/filtro-fecha/filtro-fecha.component';
import { MenuOpcionesComponent } from './components/menu-opciones/menu-opciones.component';
import { OpcionesBusquedaComponent } from './components/opciones-busqueda/opciones-busqueda.component';
import { OpcionesBotonesComponent } from './components/opciones-botones/opciones-botones.component';
import { CartillaInfoComponent } from './components/cartilla-info/cartilla-info.component';
import { TablaAdaptableComponent } from './components/tabla-adaptable/tabla-adaptable.component';
import { CdkMenuModule } from '@angular/cdk/menu';
import { ModalAlertComponent } from './components/modal-alert/modal-alert.component';
import { ModalConfirmarGenericoComponent } from './components/modal-confirmar-generico/modal-confirmar-generico.component';
import { ModalComponent } from './components/modal/modal.component';
import { SelectPersonalizadoComponent } from './components/select-personalizado/select-personalizado.component';
import { MaterialModule } from '../material/material.module';
import { DataLoadingComponent } from './components/data-loading/data-loading.component';
import { ToggleSwitchComponent } from './components/toggle-switch/toggle-switch.component';
import { StylizedCheckboxComponent } from './components/stylized-checkbox/stylized-checkbox.component';
import { EstiloInputDirective } from '../core/directivas/estilo-input.directive';
import { EstiloLabelDirective } from '../core/directivas/estilo-label.directive';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SpinnerManualComponent } from './components/spinner-manual/spinner-manual.component';
import { DocumentosUsuarioComponent } from './components/documentos-usuario/documentos-usuario.component';

const moduleImports: any[] = [
  CommonModule,
  RouterModule,
  FontAwesomeModule,
  FormsModule,
  ReactiveFormsModule,
  MaterialModule,
  MatAutocompleteModule,
  CdkMenuModule,
];

const standaloneImports: any[] = [
  ButtonComponent,
  IconComponent,
  FiltroFechaComponent,
  MenuOpcionesComponent,
  OpcionesBusquedaComponent,
  CartillaInfoComponent,
  TablaAdaptableComponent,
  DataLoadingComponent,
  ToggleSwitchComponent,
  StylizedCheckboxComponent,
  SpinnerComponent,
  SpinnerManualComponent,
  ModalAlertComponent,
  ModalConfirmarGenericoComponent,
  ModalComponent,
  SelectPersonalizadoComponent,
  DocumentosUsuarioComponent,
];

const declaredComponents: any[] = [
  OpcionesBotonesComponent,
];

const directives: any[] = [
  EstiloInputDirective,
  EstiloLabelDirective,
];

@NgModule({
  imports: [
    ...moduleImports,
    ...standaloneImports,
    ...directives,
  ],
  exports: [
    ...moduleImports,
    ...standaloneImports,
    ...declaredComponents,
    ...directives,
  ],
  declarations: [
    ...declaredComponents,
  ]
})
export class SharedModule { }
